import __var_0__ from '@stdlib/math/base/special/sqrt';
import __var_1__ from '@stdlib/math/base/special/exp';
import __var_2__ from '@stdlib/math/base/special/ln';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var sqrt = __var_0__;
var exp = __var_1__;
var ln = __var_2__;


// VARIABLES //

// (R*phi(R) + Pr(X>=R))*sqrt(2\pi)
var V = 9.91256303526217e-3;


// MAIN //

/**
* Returns an array containing coordinates such that each rectangle has the same area.
*
* @private
* @param {PositiveInteger} N - number of rectangles
* @param {number} rTail - start of right tail
* @returns {NumberArray} coordinate array
*
* @example
* var X = coordsArray( 128, 3.44 );
* // returns <Array>
*/
function coordsArray( N, rTail ) {
	var X;
	var f;
	var i;

	X = new Array( N+1 );
	f = exp( -0.5 * rTail * rTail );
	X[ 0 ] = V / f; // [0] is bottom block: V / f(R)
	X[ 1 ] = rTail;
	X[ N ] = 0.0;
	for ( i = 2; i < N; i++ ) {
		X[ i ] = sqrt( -2.0 * ln( (V / X[i-1]) + f ) );
		f = exp( -0.5 * X[ i ] * X[ i ] );
	}
	return X;
}


// EXPORTS //
export default coordsArray;
